import { useCallback, useContext, useEffect, useRef, useState } from "react";

import { EnlargeRefType } from "@is/components/EnlargeModal/EnlargeModal";
import { ENLARGED_SCALE_LEVELS } from "@is/constants";
import { ViewStateContext } from "@is/contexts";

const TIME_FOR_TRANSITION = 300;

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const useManageEnlargeModal = ({ isOpen, onClose }: Props) => {
  const enlargeRef = useRef<EnlargeRefType>(null);
  const { enlargedMedias } = useContext(ViewStateContext).content;
  const [startModalTransition, setStartModalTransition] = useState(false);

  const handleClose = useCallback(() => {
    setStartModalTransition(false);
    setTimeout(() => onClose(), TIME_FOR_TRANSITION);
  }, [onClose]);

  const handleOnCloseClick = useCallback(() => {
    if (
      enlargeRef?.current?.scale &&
      enlargeRef?.current?.scale > ENLARGED_SCALE_LEVELS.MIN
    ) {
      enlargeRef.current.reset();

      return;
    }

    handleClose();
  }, [handleClose]);

  useEffect(() => {
    setStartModalTransition(isOpen);
  }, [isOpen]);

  return {
    enlargeRef,
    handleClose,
    handleOnCloseClick,
    startModalTransition,
    enlargedMedias,
  };
};

export default useManageEnlargeModal;
